import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PractitionerOrganizationAffiliationService {
  constructor(private http: HttpClient) {}

  public showByAffiliationId(affiliation_id: string) {
    return this.http.get(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization/${affiliation_id}`);
  }

  list() {
    return this.http.get(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization`);
  }

  show(organizationId: string) {
    return this.http.get(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization/organization/${organizationId}`);
  }

  listByPractitioner(practitionerId: string) {
    return this.http.get(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization/practitioner/${practitionerId}`);
  }

  listByPractitionerOrganization(organizationId: string, practitionerId: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-practitioner-organization/organization/${organizationId}/practitioner/${practitionerId}`
    );
  }

  create(params: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization`, params);
  }

  update(affiliationId: string, params: any) {
    return this.http.put(`${environment.apiUrl}/secretarias-affiliation-practitioner-organization/${affiliationId}`, params);
  }

  approveHoursChanges(affiliationId: string, changeRequestId: string, params: any) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-affiliation-practitioner-organization/${affiliationId}/hours-changes/${changeRequestId}/approve`,
      params
    );
  }

  refuseHoursChange(affiliationId: string, changeRequestId: string, params: any) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-affiliation-practitioner-organization/${affiliationId}/hours-changes/${changeRequestId}/refuse`,
      params
    );
  }
}
